import { createContext } from 'preact'
import { Page } from 'scripts/type'
import { StateUpdater } from 'preact/hooks'
import { WIDGET_WIDTH } from 'scripts/constants'

type SurveyContextProps = {
  pages: Page[]
  activePageIndex: number
  wrapperMaxWidth: number
  setActivePageIndex?: StateUpdater<number>
  lastSubmitFieldCode?: string
  setLastSubmitFieldCode?: StateUpdater<string | undefined>
}

const SurveyContext = createContext<SurveyContextProps>({
  pages: [],
  activePageIndex: 0,
  wrapperMaxWidth: WIDGET_WIDTH.NORMAL,
})

export default SurveyContext
